import { CheckboxFormField, IFormRender } from '@busybusy/webapp-react-ui';
import { bitwisePayloadDisabler } from 'components/foundation/BitwiseGroup/util/Util';
import BitwiseGroupFormField from 'components/foundation/form-fields/BitwiseGroupFormField/BitwiseGroupFormField';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'utils/localize';
import { defaultBitwisePayloads } from '../util/constants';

export interface IPositionProgressFormFieldsFormType {
  canTrackProgress: boolean;
  canManageProjectCostCodeQuantity: number;
}

export interface IPositionProgressFormFieldsProps<T extends IPositionProgressFormFieldsFormType> {
  form: IFormRender<T>;
}

function PositionProgressFormFields<T extends IPositionProgressFormFieldsFormType>({
  form,
}: IPositionProgressFormFieldsProps<T>) {
  return (
    <>
      <CheckboxFormField
        key={'canTrackProgress'}
        name={'canTrackProgress'}
        form={form}
        label={
          <HeaderText title={t('Track Progress')}>
            <span>{t(`Create progress entries to track work accomplished.`)}</span>
          </HeaderText>
        }
        onChange={(value) => {
          if (value) {
            form.state.data.canManageProjectCostCodeQuantity = 1;
          } else {
            form.state.data.canManageProjectCostCodeQuantity = 0;
          }
        }}
      />

      {form.state.data.canTrackProgress && (
        <>
          <HeaderText title={`${t('Manage Progress for')}:`}>
            <span>{t(`View, create, edit, and delete progress entries.`)}</span>
          </HeaderText>
          <BitwiseGroupFormField
            className="mt-2"
            name={'canManageProjectCostCodeQuantity'}
            payloads={bitwisePayloadDisabler(defaultBitwisePayloads, 1)}
            form={form}
          />
        </>
      )}
    </>
  );
}

export default PositionProgressFormFields;
